import styled, { css } from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const InfoBannerContainer = styled.div`
  padding: 2px 5% 4px 5%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  ${({ theme }) => css`
    background-color: ${theme.info}20;
  `}
  & .close-btn {
    position: absolute;
    right: 5%;
  }
  @media ${devices.tablet} {
    padding: 2px 20px;
  }
  @media ${devices.phoneS} {
    align-items: flex-end;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: ${({ theme }) => theme.info};
  & p {
    margin: 0 0 1px 0;
  }
  & div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    & button {
      min-width: unset;
      box-shadow: none;
      padding: 0px 4px 1px 4px;
      margin: 0 5px;
      box-sizing: border-box;
      text-transform: none;
      font-weight: normal;
    }
  }
`;
